"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.4419 5.44194C15.686 5.19786 15.686 4.80213 15.4419 4.55806C15.1978 4.31398 14.8021 4.31398 14.558 4.55806L9.99997 9.11609L5.44194 4.55806C5.19786 4.31398 4.80213 4.31398 4.55806 4.55806C4.31398 4.80213 4.31398 5.19786 4.55806 5.44194L9.11609 9.99997L4.55806 14.558C4.31398 14.8021 4.31398 15.1978 4.55806 15.4419C4.80213 15.686 5.19786 15.686 5.44194 15.4419L9.99997 10.8838L14.558 15.4419C14.8021 15.686 15.1978 15.686 15.4419 15.4419C15.686 15.1978 15.686 14.8021 15.4419 14.558L10.8838 9.99997L15.4419 5.44194Z",
    fill: fill
  }));
};

exports["default"] = _default;